import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import * as React from "react";
import { Box, Divider, Icon, IconButton, makeStyles, Menu, MenuItem, RaiseColors, TextField, Tooltip, Typography, useMediaQuery, UserThumbnail } from "client/componentLibrary";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Comment = function Comment(_ref) {
  var _comment$sender, _comment$sender2, _comment$sender3, _comment$sender4, _comment$sender5;
  var key = _ref.key,
    comment = _ref.comment,
    currentUser = _ref.currentUser,
    setCreation = _ref.setCreation,
    setCommentId = _ref.setCommentId,
    setCommentText = _ref.setCommentText,
    onDeleteComment = _ref.onDeleteComment,
    isLastComment = _ref.isLastComment;
  var matches = useMediaQuery(function (theme) {
    return theme.breakpoints.between(768, 1500);
  });
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showOptions = _React$useState2[0],
    setShowOptions = _React$useState2[1];
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    onMouseEnter: function onMouseEnter() {
      return setShowOptions(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowOptions(false);
    },
    mb: isLastComment ? "4px" : "16px",
    "data-testid": "comment-box",
    children: [/*#__PURE__*/_jsx(Box, {
      mr: "8px",
      children: /*#__PURE__*/_jsx(UserThumbnail, {
        user: {
          initials: (comment === null || comment === void 0 || (_comment$sender = comment.sender) === null || _comment$sender === void 0 ? void 0 : _comment$sender.initials) || "",
          thumbnail: (comment === null || comment === void 0 || (_comment$sender2 = comment.sender) === null || _comment$sender2 === void 0 ? void 0 : _comment$sender2.thumbnail) || ""
        }
      })
    }), /*#__PURE__*/_jsxs(Box, {
      width: matches ? "100%" : 385,
      children: [/*#__PURE__*/_jsxs(Box, {
        display: "flex",
        alignItems: "baseline",
        mb: "4px",
        children: [/*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.black,
          weight: "bold",
          children: comment === null || comment === void 0 || (_comment$sender3 = comment.sender) === null || _comment$sender3 === void 0 ? void 0 : _comment$sender3.fullName
        }), /*#__PURE__*/_jsx(Box, {
          ml: "8px",
          children: /*#__PURE__*/_jsx(Typography, {
            color: RaiseColors.gray200,
            variant: "paragraph_xsmall",
            children: moment(comment === null || comment === void 0 ? void 0 : comment.createdDate).format("ll")
          })
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        color: RaiseColors.gray400,
        weight: "regular",
        children: comment === null || comment === void 0 ? void 0 : comment.text
      })]
    }), ((comment === null || comment === void 0 || (_comment$sender4 = comment.sender) === null || _comment$sender4 === void 0 ? void 0 : _comment$sender4.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && showOptions || (comment === null || comment === void 0 || (_comment$sender5 = comment.sender) === null || _comment$sender5 === void 0 ? void 0 : _comment$sender5.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && matches) && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Menu, {
        renderToggle: function renderToggle(_ref2) {
          var handleOpenClick = _ref2.handleOpenClick;
          return /*#__PURE__*/_jsx(IconButton, {
            onClick: handleOpenClick,
            size: "small",
            className: "fal fa-ellipsis-h",
            "data-testid": "actions-toggle"
          });
        },
        children: [/*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            setCreation(false);
            setCommentId(comment === null || comment === void 0 ? void 0 : comment.id);
            setCommentText(comment === null || comment === void 0 ? void 0 : comment.text);
          },
          "data-testid": "comments-edit-btn",
          children: /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            children: [/*#__PURE__*/_jsx(Box, {
              mr: 1,
              mt: 0.25,
              children: /*#__PURE__*/_jsx(Icon, {
                fontSize: "inherit",
                className: "fal fa-edit",
                color: RaiseColors.black
              })
            }), /*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsx(Typography, {
                color: RaiseColors.black,
                children: "Edit"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            return onDeleteComment(comment === null || comment === void 0 ? void 0 : comment.id);
          },
          "data-testid": "comments-delete-btn",
          children: /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            children: [/*#__PURE__*/_jsx(Box, {
              mr: "8px",
              mt: 0.25,
              children: /*#__PURE__*/_jsx(Icon, {
                fontSize: "inherit",
                className: "fal fa-trash-alt",
                color: RaiseColors.black
              })
            }), /*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsx(Typography, {
                color: RaiseColors.black,
                children: "Delete"
              })
            })]
          })
        })]
      })
    })]
  }, key);
};
var commentsStyles = makeStyles(function (theme) {
  return {
    commentsBox: {
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: "70vh"
    },
    commentsBoxPadded: {
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: "70vh",
      height: "60vh",
      backgroundColor: RaiseColors.grayNav
    },
    input: {
      flexGrow: 1,
      marginRight: 16,
      marginLeft: 8,
      marginTop: 8,
      "& .MuiOutlinedInput-root": {
        borderRadius: 32,
        borderColor: RaiseColors.gray100,
        color: RaiseColors.gray400,
        padding: "0px",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "1px solid ".concat(RaiseColors.gray200)
        }
      },
      "& .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense": {
        paddingTop: 7,
        paddingBottom: 7
      }
    },
    "new": {
      color: RaiseColors.bluePeeps,
      paddingLeft: 10
    }
  };
});
var Comments = function Comments(_ref3) {
  var _ref3$comments = _ref3.comments,
    comments = _ref3$comments === void 0 ? [] : _ref3$comments,
    currentUser = _ref3.currentUser,
    entityId = _ref3.entityId,
    onCreateComment = _ref3.onCreateComment,
    onUpdateComment = _ref3.onUpdateComment,
    onDeleteComment = _ref3.onDeleteComment,
    showNotification = _ref3.showNotification,
    showEmptyState = _ref3.showEmptyState,
    showPadding = _ref3.showPadding;
  var classes = commentsStyles();
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    commentText = _React$useState4[0],
    setCommentText = _React$useState4[1];
  var _React$useState5 = React.useState(""),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    commentId = _React$useState6[0],
    setCommentId = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    creation = _React$useState8[0],
    setCreation = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    activated = _React$useState0[0],
    setActivated = _React$useState0[1];
  var onSend = function onSend() {
    if (creation) {
      onCreateComment({
        entityId: entityId,
        commentText: commentText
      });
    } else {
      onUpdateComment({
        entityId: commentId,
        commentText: commentText
      });
    }
    setCommentText("");
    setCreation(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      className: showPadding ? classes.commentsBoxPadded : classes.commentsBox,
      flexGrow: "1",
      children: showEmptyState && (comments === null || comments === void 0 ? void 0 : comments.length) === 0 ? /*#__PURE__*/_jsx(Box, {
        p: showPadding ? 3 : 0,
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.black,
          children: "No comments yet"
        })
      }) : /*#__PURE__*/_jsx(Box, {
        p: showPadding ? 3 : 0,
        children: comments === null || comments === void 0 ? void 0 : _mapInstanceProperty(comments).call(comments, function (comment, index) {
          var _comment$commentstate, _context;
          return /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Comment, {
              isLastComment: comments.length - 1 === index,
              comment: comment,
              currentUser: currentUser,
              setCreation: setCreation,
              setCommentId: setCommentId,
              setCommentText: setCommentText,
              onDeleteComment: onDeleteComment
            }), showNotification && (comment === null || comment === void 0 || (_comment$commentstate = comment.commentstateSet) === null || _comment$commentstate === void 0 ? void 0 : _includesInstanceProperty(_context = _comment$commentstate.edges).call(_context, function (state) {
              var _state$node;
              return (state === null || state === void 0 || (_state$node = state.node) === null || _state$node === void 0 || (_state$node = _state$node.user) === null || _state$node === void 0 ? void 0 : _state$node.id) !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
            })) && /*#__PURE__*/_jsxs(Box, {
              display: "flex",
              children: [/*#__PURE__*/_jsx(Divider, {
                style: {
                  width: "87%",
                  marginTop: 10
                },
                color: RaiseColors.bluePeeps
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph_xsmall",
                color: RaiseColors.bluePeeps,
                weight: "semibold",
                children: "New"
              })]
            })]
          }, index);
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
      py: showPadding ? 1.5 : 0,
      px: showPadding ? 3 : 0,
      mb: showPadding ? 0 : 1.5,
      children: [/*#__PURE__*/_jsx(Box, {
        mr: "4px",
        mt: "8px",
        children: currentUser && /*#__PURE__*/_jsx(UserThumbnail, {
          user: {
            initials: currentUser.initials || "",
            thumbnail: currentUser.thumbnail || ""
          }
        })
      }), /*#__PURE__*/_jsx(Box, {
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(TextField, {
          fullWidth: true,
          multiline: true,
          size: "small",
          placeholder: "Comment here",
          variant: "outlined",
          value: commentText,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              e.stopPropagation();
              e.preventDefault();
              onSend();
            }
          },
          onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setCommentText(value);
          },
          className: classes.input,
          onMouseEnter: function onMouseEnter() {
            return setActivated(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setActivated(false);
          },
          inputProps: {
            style: {
              padding: "8px 16px"
            }
          }
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: "Press enter to send",
        "aria-label": "send",
        children: /*#__PURE__*/_jsx(Box, {
          pl: 3,
          mb: 1,
          alignSelf: "flex-end",
          children: /*#__PURE__*/_jsx(IconButton, {
            onClick: onSend,
            "data-testid": "send-btn",
            children: /*#__PURE__*/_jsx(Icon, {
              className: "far fa-paper-plane",
              color: activated ? RaiseColors.bluePeeps : RaiseColors.gray200,
              fontSize: 16
            })
          })
        })
      })]
    })]
  });
};
export default Comments;